import { SCHOOL_SET_DETAIL } from 'store/types';

export const storeSchoolDetail = (data) => {
  return {
    type: SCHOOL_SET_DETAIL,
    payload: data,
  };
};
